import React, { Component, useEffect } from 'react';
import connect from 'react-redux/es/connect/connect';
import { isMobile } from "react-device-detect";
import '../../global.css';
import MobileParentWaitingWrapper from './styles/m-parentwaiting.style';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Loader from '../../../components/Loader/loader';
import * as PatientActions from '../../../actions/patient';
import * as TherapistActions from '../../../actions/therapist';

//Video Calls
import { useAppState } from '../../../state';
import { VideoProvider } from '../../../components/VideoProvider';
import PermissionBox from '../../../components/permissionBox/permissionBox';
import ErrorDialog from '../../../components/ErrorDialog/ErrorDialog';
import App from '.././videoCall/App';
import {getMuteUnmuteStatus} from '../../../state/useFirebaseAuth/useFirebaseAuth';
import * as PatientApis from '../../../apis/patient'

// import { useAppState } from '../../state';
const dateFormat = 'MM/DD/YYYY';


const connectionOptions  = {
	bandwidthProfile: {
	  video: {
		mode: 'collaboration',
		renderDimensions: {
		  high: { height: 1080, width: 1920 },
		  standard: { height: 90, width: 160 },
		  low: { height: 90, width: 160 },
		},
	  },
	},
	dominantSpeaker: true,
	maxAudioBitrate: 12000,
	networkQuality: { local: 1, remote: 1 },
	preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
  };


const VideoApp = (props) => {
	const { error, setError } = useAppState();
	const { dispatch, patient, match } = props;
	const { activeCall } = patient;

	useEffect(() => {
		if (activeCall && activeCall.callStatus && activeCall.callStatus.toLowerCase() === "on call") {
			dispatch(PatientActions.getParticipantList(match.params.therapistRoom));

		}

	}, []);

	return (
	  <VideoProvider options={connectionOptions} onError={setError}>
		<ErrorDialog dismissError={(err) => {
			if(error.code === 20104){
				window.sessionStorage.removeItem('twilioPatientToken');
			}
			
			window.location.reload();
		  return setError(null)
		  }} error={error} />
		<App {...props}/>
	  </VideoProvider>
	);
  };

class MobileParentWaiting extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fullScreen: false,
			showSidebar: false,
			active: false,
			showLocalVideo: false
		}
        this.formInterval = undefined;
		this.endCall = this.endCall.bind(this);
		this.toggleFullScreen=this.toggleFullScreen.bind(this);
		this.toggleSidebar=this.toggleSidebar.bind(this);
		this.stopInterval=this.stopInterval.bind(this);
	}

	componentDidMount(){
		const callId = window.localStorage.getItem("patientCallId");
		const { dispatch, match } = this.props;
		getMuteUnmuteStatus('participantsAudioStatus', 'videoroomcall-' + match.params.therapistRoom, this.muteAudio)
		
		//window.localStorage.setItem('newParticipant', "true")
		//dispatch(PatientActions.getParticipantList(match.params.therapistRoom));

		// PatientApis.getParticipants(match.params.therapistRoom).then(result => {
		// 	if (result.data && result.data.length >= 2) {
		// 		window.localStorage.setItem('newParticipant', "true")
		// 	} else {
		// 		window.localStorage.removeItem('newParticipant')
		// 	}
		// }).catch(e => {
		// 	console.log(e)
		// })

		dispatch(PatientActions.getActiveCallDetails({callId}));
	}

	muteAudio = (data) => {
		window.localStorage.setItem('muteAudio', JSON.stringify(data))
	}

	endCall(){

		const { dispatch } =this.props;
		const callId = window.localStorage.getItem("patientCallId");
		const status = "End Call"
		dispatch(TherapistActions.changeCallStatus({callId, status}, () => {

			window.localStorage.removeItem("therapistCallId");
			window.localStorage.removeItem('patientCallId');
			window.sessionStorage.removeItem('twilioPatientToken');
            window.sessionStorage.setItem('therapistConnecting', "no");
            window.sessionStorage.setItem('patientConnecting', "no");
			if(this.formInterval){
				this.stopInterval();
			}
			window.location.replace('/thank-you');
		}))
	} 

	componentDidUpdate(prevProps){
		const callId = window.localStorage.getItem("patientCallId");
		const { dispatch, patient, match } = this.props;
		const { activeCall } = patient;
		if(activeCall.callStatus && (activeCall.callStatus.toLowerCase() === "waiting" || activeCall.callStatus.toLowerCase() === "on call" )&& !this.formInterval){
			this.formInterval = setInterval(() => {
				dispatch(PatientActions.getActiveCallDetails({callId}));
			}, 5000)
		}
		//dispatch(PatientActions.getParticipants(match.params.therapistRoom));

		// if(activeCall.callStatus.toLowerCase() === "waiting" && this.formInterval){
		// 	this.stopInterval();
		// }
		if(activeCall.callStatus && activeCall.callStatus.toLowerCase() === "end call" ){
			window.localStorage.removeItem('patientCallId');
			window.sessionStorage.removeItem('twilioPatientToken');
            window.sessionStorage.setItem('patientConnecting', "no");
			if(this.formInterval){
				this.stopInterval();
			}
			window.location.replace('/thank-you');
		}
	}
	
	verifyUser = () => {
		this.setState({
			showLocalVideo: true
		});
	}

	toggleFullScreen(){
		this.setState(prevState =>({
			fullScreen : !prevState.fullScreen
		}))
	}

	toggleSidebar(){
		this.setState(prevState =>({
			showSidebar : !prevState.showSidebar
		}))
	}

	stopInterval(){
        clearInterval(this.formInterval); 
	}

	render() {
		const { patient, setting } = this.props;
		const { activeCall } = patient;
		if(!activeCall.callId){
			return <Loader />
		}
		let showSidebar = true;
		
		if(this.state.fullScreen){
			showSidebar = false;
		}
		if(isMobile && !this.state.showSidebar){
			showSidebar = false;
		}
		

		let userStatusClass = "";
		let { currentUserStatus } = setting;
		if(!currentUserStatus){
			if(activeCall.therapistCallStatus && activeCall.callStatus.toLowerCase() !== "on call"){
				currentUserStatus = "on another call"; 
			}else{
				currentUserStatus = "available";
			}
		}else{
			if(activeCall.therapistCallStatus && activeCall.callStatus.toLowerCase() !== "on call"){
				currentUserStatus = "on another call"; 
			}
		}
		
		if(currentUserStatus.toLowerCase() === "available"){
			userStatusClass="available";
		}else if(currentUserStatus.toLowerCase() === "on another call"){
			userStatusClass="on-other-call";
		}else if(currentUserStatus.toLowerCase() === "busy"){
			userStatusClass = "busy"
		}
		return (
				<MobileParentWaitingWrapper>
					{activeCall.callStatus.toLowerCase() !== "on call"  && <header className="sectionHeader">
				<div className="menu-icon" onClick={this.toggleSidebar}>
				<span></span><span></span><span></span>
				</div>
				<div className="m-logo">
				<a><img className="logo" src="/images/kure-logo.png" width="70" alt="kure logo" /></a>
				<h3>video room</h3>
				</div>
				{/* <div className="top-bar">
					<h1>To invite someone to your waiting room, share this link:</h1>
					
				</div> */}
				
				</header>}
				{activeCall.callStatus.toLowerCase() !== "on call"  &&
				
				<VideoProvider options={connectionOptions}>
					<PermissionBox camNamee={activeCall.patient} showLocalVideo={this.state.showLocalVideo} verifyUser={this.verifyUser}/>	
				</VideoProvider>
				}
				<div className="parentWaiting">
				<div className={this.state.showSidebar ? 'overlay show': 'overlay hide'}></div>
				<aside className={this.state.showSidebar ? 'page-header slidein': 'page-header slideout'}>
						<nav>
							<a href="/"><img className="logo" src="/images/kure-logo.png" width="70" alt="kure logo" /></a>
							<h3>video room</h3>
						</nav>
						<span className="close-sidebar" onClick={this.toggleSidebar}>×</span>
						<Scrollbars>
						<div className="scrollable-content">
						<section className="patient-queue mt-40">
							<h1 className="section-title">available</h1>
						{/* {activeCall.therapistCallStatus && activeCall.therapistCallStatus.toLowerCase() !== "on call" && activeCall.callStatus.toLowerCase() !== "on call"? 
						<h4 className="user__not__available">Your therapist is not available yet</h4>
						:
						<div className="user__profile">
							<div className="thumb-inner"><img src="https://static.sendbird.com/sample/profiles/profile_35_512px.png" /><h1>{activeCall.therapistName}</h1></div>
							{activeCall.therapistCallStatus && activeCall.callStatus.toLowerCase() !== "on call" &&  <div className="status">ON ANOTHER CALL</div>}
						</div>
						} */}
						</section>
						<section className="participantList">
							<ul>
								<li>
									<div className="participantList_status">
										<div className="participantList_thumb">
											<img src="https://static.sendbird.com/sample/profiles/profile_35_512px.png" />
										</div>
										<div className="participant_rightpan">
											<div className="participantName">{activeCall.therapistName}</div>
											<div className={`user-status ${userStatusClass}`}>{currentUserStatus}</div>
										</div>
									</div>
								</li>
							</ul>
					</section>
						</div>
						</Scrollbars>
					</aside>
				<section className="page-content">
					{activeCall.callStatus.toLowerCase() !== "on call" ? <div className="call-waiting-msg"><h1>Your call should start soon</h1><button className="exitvideoRoom_btn no-error-message" onClick={this.endCall}>exit video room</button></div> :
				<VideoApp {...this.props} {...this.state} 
						endCall={this.endCall} 
						toggleSidebar={this.toggleSidebar}
						showLocalVideo={this.state.showLocalVideo} 
						verifyUser={this.verifyUser}
						toggleFullScreen={this.toggleFullScreen}/>}
				</section>
				
			</div>
				</MobileParentWaitingWrapper>
		  ) 
	}
}

function mapStateToProps(state) {
	return state;
}

export default connect(mapStateToProps)(MobileParentWaiting);

